import { Component, Input, OnInit } from '@angular/core';
import { PolicyRepoService } from '@client/app/services/api/policy-repo/policy-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import {
    PagesPolicyDialogLinksPagesComponent,
} from '@client/app/pages/policy/dialogs/links/pages/pages-policy-dialog-links-pages.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-policy-dialog-links',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <page-header
                    panelClass="row"
                    panelLeftClass="col-32 col-md-28 col-lg-30 mt-2"
                    panelRightClass="col-16 col-md-20 col-lg-18"
                    [header]="'Content with Policy Matches' | translate">
                <page-header-content>
                    <div class="mon-dialog-delay-fadein d-flex">
                        <div class="mt-1">
                            <csv-export-button [exports]="exports"></csv-export-button>
                        </div>
                        <div class="mt-1 pl-4 flex-fill-column-width">
                            <table-search [minSearchLength]="3"
                                          class="block mr-2"
                                          theme="grey-theme"
                                          [placeholderTxt]="'Search...' | translate"
                                          [(model)]="search"
                                          (getPage)="onSearch($event)">
                            </table-search>
                        </div>
                    </div>
                </page-header-content>
            </page-header>
        </div>

        <div class="mon-dialog-body">
            <div class="card panel-monsido-card mx-3 mt-3">
                <div class="card-body">
                    <table-container
                            [progress]="progress"
                            [collection]="links"
                            (onPageChange)="onPageChange($event)"
                            [noResultMessage]="'Congratulations no violations were found' | translate"
                            (onPerPageChange)="onPageSizeChange($event)"
                            class="pages-table-wrapper">
                        <table class="table table-hover table-fixed policy-violations-table table-with-labels">
                            <thead>
                            <tr>
                                <th class="col-md-32" translate>
                                    Title and URL
                                </th>
                                <th class="col-md-4" translate>
                                    Response code
                                </th>
                                <th class="col-md-4" translate>
                                    Type
                                </th>
                                <th class="col-md-8">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let link of links">
                                <td class="text-ellipsis text-v-middle">
                                    <a [attr.href]="link.url" target="_blank" aria-describedby="linkOpensInNewTab">{{ link.url }}</a>
                                </td>
                                <td class="text-v-middle">
                                    {{link.status_code}}
                                </td>
                                <td class="text-v-middle">
                                    <span class="label label-default">{{ getLinkTypeCapitalized(link.type) }}</span>
                                </td>
                                <td class="text-right">
                                    <pages-button (callback)="openPagesDialog(link)"
                                                  [monAriaLabel]="'Go to page details' | translate"
                                                  [ngModel]="link.html_pages_count">
                                    </pages-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    `,
})
export class PagesPolicyDialogLinksComponent extends BaseContainerComponentController implements OnInit {
    @Input() policy: any;
    @Input() pageCount: any;

    links: any[] = [];
    exports: any[] = [];
    progress: any;

    constructor (
        private policyRepoService: PolicyRepoService,
        private translateService: TranslateService,
    ) {
        super({ table: true });
    }

    ngOnInit () {
        this.links = [];
        this.currentSort = { by: 'html_pages_count', direction: 'desc' };
        this.exports = [
            {
                name: this.translateService.getString('Content with Policy Matches'),
                data: {
                    category: 'policy_links',
                    category_ref: this.policy.id,
                },
            },
            {
                name: this.translateService.getString('Content with Policy Matches (Advanced)'),
                data: {
                    category: 'advanced_policy_links',
                    category_ref: this.policy.id,
                },
            },
        ];
        this.getPage();
    }

    override getPage = () => {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
            search: this.search || null,
        };

        this.progress = this.policyRepoService.domainGetPolicyLinks(this.policy.id, params).then((links: any) => {
            this.links = links;
        }, () => {});
    };

    openPagesDialog (link: any) {
        const params = {
            body: PagesPolicyDialogLinksPagesComponent,
            size: 'md',
            data: { link: link, policy: this.policy },
        };
        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

    getLinkTypeCapitalized (type: string): string {
        const capitalizePipe = this.pipeService.get('capitalize');
        return capitalizePipe ? capitalizePipe(type) : type;
    }
}
